import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@metarouter-private/mr-mui';

import ConfirmDeleteMessage from './ConfirmDeleteMessage';
import ConfirmDeleteIntegrationsList from './ConfirmDeleteIntegrationsList';
import ConfirmDeleteInput from './ConfirmDeleteInput';

export default function ConfirmDeleteContent({
  clusterName,
  loadingIntegrations,
  deployedIntegrations,
  integrationsLoadError,
  onConfirmInputChange,
  writeKey,
}) {
  const isDeployed = deployedIntegrations.length > 0;

  return (
    <Stack spacing={3}>
      <ConfirmDeleteMessage clusterName={clusterName} isDeployed={isDeployed} />

      <ConfirmDeleteIntegrationsList
        loadingIntegrations={loadingIntegrations}
        deployedIntegrations={deployedIntegrations}
        integrationsLoadError={integrationsLoadError}
      />

      <ConfirmDeleteInput writeKey={writeKey} onConfirmInputChange={onConfirmInputChange} />
    </Stack>
  );
}

ConfirmDeleteContent.propTypes = {
  clusterName: PropTypes.string,
  loadingIntegrations: PropTypes.bool,
  deployedIntegrations: PropTypes.array,
  integrationsLoadError: PropTypes.object,
  onConfirmInputChange: PropTypes.func,
  writeKey: PropTypes.string,
};
